import { busService } from "../bus";
import { LocalUserInfoMessage, PeerRemovedMessage, UserInfoMessage, PeerCreatedMessage } from "../../messages/session/PeerMessages";
import { ChangeLocalUserInfoMessage } from "../../messages/session/SessionMessages";
import { UNDEFINED_USER } from "./UserTypes";
class CoreUserService {
    constructor() {
        this.connection = busService.connection("CoreUserService");
        this.localUser = UNDEFINED_USER;
        this.users = new Map();
        this.usersByClientIdx = new Map();
        this.handlePeerCreatedMessage = (msg) => {
            const user = {
                clientId: msg.clientId,
                clientIdx: msg.clientIdx,
                avatar: UNDEFINED_USER.avatar
            };
            this.users.set(msg.clientId, user);
            this.usersByClientIdx.set(msg.clientIdx, user);
        };
        this.handlePeerRemovedMessage = (msg) => {
            const user = this.users.get(msg.clientId);
            if (!user)
                return;
            this.usersByClientIdx.delete(user.clientIdx);
            this.users.delete(msg.clientId);
        };
        this.handleLocalUserInfoMessage = (msg) => {
            this.localUser.clientId = msg.clientId;
            this.localUser.clientIdx = msg.clientIdx;
            this.localUser.identity = msg.identity;
            this.localUser.avatar = msg.avatar;
            this.users.set(this.localUser.clientId, this.localUser);
            this.usersByClientIdx.set(this.localUser.clientIdx, this.localUser);
        };
        this.handleChangeLocalUserInfoMessage = (msg) => {
            if (!msg.params.customUsername)
                return;
            this.localUser.customUsername = msg.params.customUsername;
            if (msg.params.avatar) {
                this.localUser.avatar = msg.params.avatar;
            }
        };
        this.handleUserInfoMessage = (msg) => {
            let user = this.users.get(msg.clientId);
            if (!user) {
                user = {
                    clientId: msg.clientId,
                    clientIdx: msg.clientIdx,
                    avatar: msg.avatar
                };
                this.users.set(msg.clientId, user);
            }
            user.identity = msg.identity;
            user.customUsername = msg.customUsername;
            user.avatar = msg.avatar;
        };
        this.connection.subscribeByType(PeerCreatedMessage, this.handlePeerCreatedMessage);
        this.connection.subscribeByType(PeerRemovedMessage, this.handlePeerRemovedMessage);
        this.connection.subscribeByType(LocalUserInfoMessage, this.handleLocalUserInfoMessage);
        this.connection.subscribeByType(ChangeLocalUserInfoMessage, this.handleChangeLocalUserInfoMessage);
        this.connection.subscribeByType(UserInfoMessage, this.handleUserInfoMessage);
    }
    getLocalUser() {
        return this.localUser;
    }
    isLocalUser(user) {
        return user.clientId === this.localUser.clientId;
    }
    hasUser(clientId) {
        return this.users.has(clientId);
    }
    hasUserByClientIdx(clientIdx) {
        return this.usersByClientIdx.has(clientIdx);
    }
    getUser(clientId) {
        return this.users.get(clientId);
    }
    getUserByClientIdx(clientIdx) {
        return this.usersByClientIdx.get(clientIdx);
    }
    getDisplayName(clientId) {
        const user = this.getUser(clientId);
        if (!user) {
            return "Unknown";
        }
        return this.getDisplayNameByUser(user);
    }
    getDisplayNameByUser(user) {
        if (user.customUsername) {
            return user.customUsername;
        }
        if (user.guest) {
            return "Guest";
        }
        if (user.identity) {
            return `${user.identity.firstname} ${user.identity.lastname}`;
        }
        return "Guest";
    }
}
export const coreUserService = new CoreUserService();
